import { Reveal } from "@/components/Reveal";
import { SectionLabel } from "@/components/home/SectionLabel";
import { WHY_POINTS, IMAGES } from "@/data/content";
import { Check } from "lucide-react";

export function WhySection() {
    return (
        <section className="bg-sage text-cream relative z-10 overflow-hidden">
            <div className="glow-terracotta absolute -bottom-32 -left-20 w-[560px] h-[560px] pointer-events-none opacity-60" />
            <div className="relative max-w-[1240px] mx-auto px-6 lg:px-10 py-24 grid lg:grid-cols-2 gap-14 items-center">
                <Reveal>
                    <SectionLabel className="text-terracotta">Why DentAssists</SectionLabel>
                    <h2 className="font-heading text-4xl sm:text-5xl tracking-tight mt-4">
                        Dental-only. Not a generalist billing shop.
                    </h2>
                    <p className="text-cream/70 leading-relaxed mt-6 max-w-lg">
                        We work exclusively with dental practices, so our team already knows CDT
                        codes, dental payer quirks, and the difference between a missing frequency
                        limitation and a real denial.
                    </p>
                    <ul className="mt-8 space-y-4">
                        {WHY_POINTS.map((p) => (
                            <li key={p} className="flex items-start gap-3 text-cream/90">
                                <Check size={18} className="text-terracotta shrink-0 mt-0.5" />
                                <span className="text-sm leading-relaxed">{p}</span>
                            </li>
                        ))}
                    </ul>
                </Reveal>
                <Reveal delay={0.15}>
                    <div className="relative">
                        <div className="absolute -top-4 -right-4 w-full h-full border border-cream/20 rounded-sm hidden lg:block" />
                        <div className="img-frame relative rounded-sm">
                            <img
                                src={IMAGES.trust}
                                alt="Dental professional"
                                className="w-full h-[440px] object-cover rounded-sm"
                            />
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
